import { Card, Skeleton } from 'antd';
import React from 'react';

export default function SkeletonBox() {
    return (
        <Card>
            <Skeleton
                paragraph={{ rows: 12 }}
                active
            />
        </Card>
    );
}
